<template src="../../templates/form/sickness-form.pug" lang="pug"></template>

<script>
import Modal from './Modal.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { maxLength, maxValue, minLength, required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import { format } from 'date-fns'
import _filter from 'lodash/filter'
import _find from "lodash/find"
import Vue from "vue"
export default {
    name: "SicknessForm",
    components: {
        Modal,
    },
    props: ['sickAnimal'],
    data() {
        return {
            animal: JSON.parse(JSON.stringify(this.sickAnimal)),
            newSickness: {
                animal: null,
                onGoing: true,
                sickness: null
            }
        }
    },
    computed: {
        ...mapGetters([
            'selectedFarm',
            'sicknessList'
        ]),
        _onGoing: {
            get(val) {
                console.log(val)
            },
            set(val, $event) {
                console.log('ongoing val', val)
                console.log('ongoing event', $event)
            }
        },
        isFormValid() {
            return true
        }
    },
    created() {
        this.newSickness.animal = this.sickAnimal.id
    },
    methods: {
        ...mapActions(['editAnimalSicknesses']),
        close() {
            this.$router.go(-1)
        },
        submit() {
            if (this.isFormValid) {
                this.editAnimalSicknesses({animal: this.animal, newSickness: this.newSickness})
                this.close()
            }
        },
        translation(name) {
            let sicknessInfo = _find(this.sicknessList, ['name', name])
            return window.navigator.language
                    ? sicknessInfo['name_' + window.navigator.language.substring(0,2)]
                    : sicknessInfo['name_ru']
        },
    }
}
</script>

<style lang="sass">
@import '../../sass/mixin/color'
@import '../../sass/mixin/flex'

#sickness-modal
    .modal-container
        .modal-header
            background-color: $dd-light-orange
            color: white
        .modal-body
            form
                input, input:focus, input:valid, .multiselect
                    border-left: 8px solid $dd-light-orange
                .select
                    @include flex-center
                    .form-select
                        width: 100%
                        height: 40px
                        background: url('/img/br_down.png') 96% no-repeat #fff
                        border-left: 8px solid $dd-light-orange
                        border-bottom: none
                        border-right: none
                        border-top: transparent
                        padding: 0.25em
                        font-size: 16px
                        font-weight: bold
                        -webkit-appearance: none
                        -moz-appearance: none
                        appearance: none

</style>